import React, { Component } from 'react';
import WeatherDataSource from 'dataSource/weatherDataSource'
import WeatherView from './weatherView';
import WeatherDebugView from './weatherDebugView';
import LoaderView from 'components/loaderView';
import ErrorView from 'components/errorView';
import WeatherData from 'models/weatherData'
import Utils from 'common/utils'
import Constants from 'common/constants'
import CacheStore from 'stores/cacheStore'
import SIFormatter from 'common/siFormatter';
import RemoteLogger from 'common/remoteLogger';
import Theme from 'common/theme';
import VersionManager from 'manager/versionManager'
import NativeAgent from 'common/nativeAgent';
import CommonComponents from 'components/commonComponents';
import RefreshDataState from 'models/refreshDataState'
import WeatherParams from 'models/weatherParams'
import LocationStore from 'stores/locationStore'
import Sidebar from "react-sidebar";
import SidebarView from 'components/sidebarView';
import LocationPermissionStore from 'stores/locationPermissionStore'
import SidebarStateStore from 'stores/sidebarStateStore'
import Analytics from 'analytics'
import ForceLocationManager from 'manager/forceLocationManager'
import 'styles/weather-container.css'
import UserIdManager from 'manager/userIdManager'
import DataSource from 'common/dataStore'
import moment from 'moment';
import DeviceTokenManger from 'manager/deviceTokenManager'

const DEFAULT_REQ_PREFIX = "REQ_"
const EXPIRY_SECS = 60 * 15 // 15 mins
const TIMEOUT_PERIOD = 1000 * 60 * 15 // 15 mins
const CACHE_SI_KEY = "weather-app-si-key"
const LOADER_DELAY = 1100;
const TOOL_TIP_SHOWN_KEY = "tool-tip-shown";
const LOCATION_MODE_LAT_LNG = Constants.WEATHER_SRC.NATIVE_GEO;
const LOCATION_MODE_IP = Constants.WEATHER_SRC.MANUAL;

const TOP_BAR_STATUS = {
    INITIAL: 0,
    SHOW: 1,
    HIDE: 2,
}

let keyframesStyle = `
@-webkit-keyframes pulse {
    from {
        -webkit-transform: rotateZ(-180deg);
        transform: rotateZ(-180deg);
    }
    to {
        -webkit-transform: rotateZ($toreplace);
        transform: rotateZ($toreplace);
    }
    `;

let mIsPremiumUser = false

export class AdView extends Component {
    constructor(props) {
        super(props);
        this.adType = props.adType;
    }
    render() {
        if (this.adType === "1") {
            return (<div className="bottom-ad-wrapper">
                <div id='div-gpt-ad-1585573621498-0' className="bottom-ad-display">
                </div>
            </div>)
        } else {
            return (<div className="second-ad-wrapper">
                <div id='div-gpt-ad-1591946681893-0'>
                </div>
            </div>)
        }
    }

    componentDidMount() {
        window.googletag.cmd.push(() => window.googletag.display('div-gpt-ad-1585573621498-0'))
        window.googletag.cmd.push(() => window.googletag.display('div-gpt-ad-1591946681893-0'))
    }
}

class WeatherApp extends Component {

    constructor(props) {
        super(props)
        this.state = {
            weatherResponse: {},
            isLoading: true,
            hasFailed: false,
            emptyCoords: false,
            si: Constants.SI_UNIT_US,
            lastUpdatedTime: null,
            lastRefreshTime: null,
            area: null,
            latitude: null,
            longitude: null,
            country: null,
            zipCode: null,
            showLocationTopBar: false,
            locationTopBarStatus: TOP_BAR_STATUS.INITIAL,
            locationMode: LOCATION_MODE_IP,
            sidebarOpen: SidebarStateStore.getIsSidebarOpen(),
            isNativeSidebarVisible: false,
            frameStyle: null,
            showSearchBar: false,
            showPremiumFeature: false,
            alertTitle: ''
        }

        /*
        NOTE:
        Why do I have a weather-params instead of directly adding these to the states above?
        - Want to update the weather-response and the area data together in the response. There should
        not be a case where the area is rendered first, then the weather-data is slowly updated later on.
        - Keeping the states above to quickly reflect other changes easily from other parts of the code. For eg,
        when area is empty and fetching from zip-code is required, it'll be easier to update the area with state after
        - Hindsight, this could've benefitted from another nesting of component. That would allow me to do the same thing
        without seemingly creating a weird situation like this :)
        */
        this.weatherParams = WeatherParams.instanceFromUrl()

        this.timeout = null;

        // This is for throttling the location refresh time
        this.lastLocationRefreshTime = null;

        // Initializing the force-location-manager
        ForceLocationManager.initialise()
    }

    isAreaEqual(prevArea, currentArea) {
        // Check explicitly for area
        var isAreaEqual = true;
        if (false === Utils.isNull(prevArea) && false === Utils.isNull(currentArea)) {
            isAreaEqual = (prevArea.city === currentArea.city &&
                prevArea.area === currentArea.area)
        } else if (false === Utils.isNull(prevArea) || false === Utils.isNull(currentArea)) {
            isAreaEqual = false;
        }
        return isAreaEqual;
    }

    handleAdsImpressionOnRefresh = (event) => {
        let slot = event.slot.getAdUnitPath();
        if (slot.includes('/')) {
            let list = slot.split('/')
            slot = list[list.length - 1]
        }

        console.log('Impression for slot', slot, 'became viewable.');
        Analytics.sendEventWithObjParams({
            category: Constants.ANALYTICS.EVENTS.CATEGORY.WEATHER_PAGE,
            action: Constants.ANALYTICS.EVENTS.ACTION.DFP_ADS_IMPRESSION,
            label: slot,
            ad_source: Constants.ANALYTICS.EVENTS.CATEGORY.WEATHER_PAGE
        })
    }

    refreshAd() {
        console.log("ad refresh requested");
        window.googletag.cmd.push(function () { window.googletag.pubads().refresh([window.topAdSlot]); })
        window.googletag.cmd.push(() => {
            window.googletag.display('div-gpt-ad-1585573621498-0')
            window.googletag.pubads().addEventListener('impressionViewable', this.handleAdsImpression)
        })

        window.googletag.cmd.push(function () { window.googletag.pubads().refresh([window.bottomAdSlot]); })
        window.googletag.cmd.push(() => {
            window.googletag.display('div-gpt-ad-1591946681893-0')
            window.googletag.pubads().addEventListener('impressionViewable', this.handleAdsImpression)
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // If any of the location specific entries change, update the url
        console.log("container update");
        var isWeatherDataEqual = (
            prevState.latitude === this.state.latitude &&
            prevState.longitude === this.state.longitude &&
            prevState.country === this.state.country &&
            prevState.zipCode === this.state.zipCode
        )

        // Check explicitly for area
        var isAreaEqual = this.isAreaEqual(prevState.area, this.state.area);

        if (false === isWeatherDataEqual || false === isAreaEqual) {
            console.log("GENERATE_URL: Generating new url")
            this.weatherParams.updateUrlInPlace();
            this.refreshAd();
            if (Utils.isNull(this.processedResp) === false) {
                this.adjustSunRiseSunsetDegree(this.processedResp.general_data, this.processedResp.current_data);
            }
            return
        }

        if (this.state.isNativeSidebarVisible && prevState.isNativeSidebarVisible !== this.state.isNativeSidebarVisible && this.state.locationMode === "IP") {
            CacheStore.get("location_last_fetched_timestamp").then(cacheVal => {
                if (!(Utils.isNull(cacheVal) || Date.now() - cacheVal < 2 * 60 * 1000)) {
                    this.fetchGeoCoordinatesBasedOnIp(prevState.area);
                }
            }).catch(function (e) {
                console.log("Error getting data from cache-store" + e)
            });
        }

        if (!!Utils.convertToNumber(this.weatherParams.showSearchBar) && prevState.showSearchBar === false) {
            this.setState({
                showSearchBar: true
            })
        }

        if (!!Utils.convertToNumber(this.weatherParams.showPremiumFeature) && prevState.showPremiumFeature === false) {
            DeviceTokenManger.storeFeatureFlagForPremiumUser(!!this.weatherParams.showPremiumFeature)
            this.setState({
                showPremiumFeature: true
            })
        }
    }

    componentDidMount() {
        this.updateSI()
        this.componentIsDisplayed()
        if (Utils.isNull(this.weatherParams.latitude) || Utils.isNull(this.weatherParams.longitude)) {
            console.log("Got either lat or lon as empty!")
            console.log("GEO_DATA: Fetching geo data")
            this.setState({ locationMode: LOCATION_MODE_IP });
            this.fetchGeoCoordinatesBasedOnIp(null);//This is the first time, previous State's area is null
        } else {
            LocationStore.addAndSendLocation(this.weatherParams)
            // Send analytics event
            Analytics.sendEvent(
                Constants.ANALYTICS.EVENTS.CATEGORY.LOC_TYPE,
                Constants.ANALYTICS.EVENTS.ACTION.LOC_NATIVE,
                null,
                null,
                true,
            )

            this.fetchAndLoadWeatherData()
        }

        if (!!Utils.convertToNumber(this.weatherParams.showSearchBar) && this.state.showSearchBar === false) {
            this.setState({
                showSearchBar: true
            })
        }

        if (!!Utils.convertToNumber(this.weatherParams.showPremiumFeature) && !this.state.showPremiumFeature) {
            this.setState({
                showPremiumFeature: true
            })
        }
        DeviceTokenManger.storeFeatureFlagForPremiumUser(!!this.weatherParams.showPremiumFeature)

        //Fetch the data for the first time, set an iterval for 15 minutes for next time onwards
        this.refreshWeatherDataForSavedLocations();
        this.refreshWeatherJobTimerId = setInterval(
            () => this.refreshWeatherDataForSavedLocations(), 15 * 60 * 1000);
    }

    refreshWeatherDataForSavedLocations() {
        var locations = LocationStore.getLocationsFromStore();
        if (!Utils.isNull(locations)) {
            var numberOfSavedLocations = locations.length;
            for (var i = 0; i < numberOfSavedLocations; i++) {
                var savedLocation = locations[i];
                WeatherDataSource.fetchWeatherDataForLocation(savedLocation['latitude'], savedLocation['longitude'], null, true);
            }
        }
    }

    fetchGeoCoordinatesBasedOnIp(previousStateArea) {
        WeatherDataSource.fetchCurrentGeoData((resp, err) => {
            var fetchedNewData = false;
            if (true === Utils.isNull(err) && false === Utils.isNull(resp)) {
                fetchedNewData = this.updateWeatherParamsWithGeoData(resp)
            }

            if (false === fetchedNewData) {
                this.setState({ emptyCoords: true });
                Analytics.sendEvent(
                    Constants.ANALYTICS.EVENTS.CATEGORY.LOCATION,
                    Constants.ANALYTICS.EVENTS.ACTION.FETCH_FAIL,
                    null,
                    null,
                    true,
                )
                return;
            } else {
                // Update the new location to the store
                CacheStore.set("location_last_fetched_timestamp", Date.now());
                LocationStore.addAndSendLocation(this.weatherParams)
                LocationStore.setCurrentLocationIndex(-1)

                // Send analytics event
                Analytics.sendEvent(
                    Constants.ANALYTICS.EVENTS.CATEGORY.LOC_TYPE,
                    Constants.ANALYTICS.EVENTS.ACTION.LOC_IP,
                    null,
                    null,
                    true,
                )

                if (!this.isAreaEqual(previousStateArea, this.weatherParams.area)) {
                    this.fetchAndLoadWeatherData()
                }
            }
        })
    }

    adjustSunRiseSunsetDegree(general_data, current_data) {
        console.log("adjust sunrise sunset");
        if (Utils.isNull(general_data) || Utils.isNull(current_data)) {
            console.log("sunset-sunrise time is NA");
            RemoteLogger.logStr("ERR: sunset-sunrise time is NA, locationMode: " + this.state.locationMode + "{" + this.state.latitude + "," + this.state.longitude + "}");
            return;
        }
        var sunRise = moment.tz(moment(current_data.sunriseTime, "HH:mm A"), general_data.timezone);
        var sunSet = moment.tz(moment(current_data.sunsetTime, "HH:mm A"), general_data.timezone);

        var totalDiff = moment.duration(sunSet.diff(sunRise)).asMinutes();

        var currentTimestamp = Math.floor(Date.now() / 1000)
        var today = moment.tz(moment.unix(currentTimestamp), general_data.timezone).format('HH:mm A');
        var timeNow = moment.tz(moment(today, "HH:mm A"), general_data.timezone);
        var diffAsOfNow = moment.duration(timeNow.diff(sunRise)).asMinutes();
        if (timeNow < sunRise) {//When current time is less than sun-rise
            diffAsOfNow = 0;
        }

        if (timeNow > sunSet) {
            diffAsOfNow = totalDiff;
        }

        console.log(" sunrise : " + sunRise + " sunset: " + sunSet + " diff: " + totalDiff + " " + diffAsOfNow + " now: " + timeNow + " " + today);

        var resultingDegree = -(180 - (180 * diffAsOfNow) / totalDiff);


        if (resultingDegree > 0) {//When curren time is after sun-set
            resultingDegree = 0
        }

        if (false === Utils.isNull(this.sunRiseSunSetTimer)) {
            clearTimeout(this.sunRiseSunSetTimer)
        }

        this.sunRiseSunSetTimer = setTimeout(
            () => {
                this.adjustSunRiseSunsetDegree(this.processedResp.general_data, this.processedResp.current_data);
            },
            60 * 60 * 1000,
        )

        var updatedStyle = keyframesStyle.replace("$toreplace", resultingDegree + "deg");
        if (updatedStyle !== this.state.frameStyle) {
            this.setState({ frameStyle: updatedStyle });
        }
    }


    render() {
        if (this.state.emptyCoords === true) {
            console.log("Got empty lat-lon args!")
            return (
                <ErrorView />
            )
        } else if (this.state.isLoading === true) {
            return (
                <LoaderView locationMode={this.state.locationMode} />
            )
        } else {
            if (this.state.hasFailed === true) {
                return (
                    <ErrorView />
                )
            }

            mIsPremiumUser = DataSource.getItem(Constants.IS_PREMIUM_USER)

            // Process the response here and send it to the weather-view
            var processedResp = this.processWeatherResponse(this.state.weatherResponse, this.state.area)
            this.processedResp = processedResp;
            console.log("Processed response - ")
            console.log(processedResp)
            console.log("Current data -")


            var isDataValid = SIFormatter.isValidCurrentTempForWeatherData(processedResp.current_data, processedResp.general_data);
            if (isDataValid === false) {
                console.log("Got invalid data!")
                return (
                    <ErrorView />
                )
            }

            // Checking if the current url has the debug mode on
            var debugMode = false;
            var debugVal = Utils.getValForKeyFromCurrentUrl("debug");
            if (typeof (debugVal) === "string" && debugVal !== null) {
                if (debugVal.toLowerCase() === "true") {
                    debugMode = true;
                }
            }

            if (false === debugMode) {
                return (
                    <Sidebar
                        sidebarClassName="weather-sidebar-wrapper"
                        sidebar={
                            <SidebarView
                                entry_clicked_cb={this.onSidebarEntryClicked.bind(this)}
                                fetch_geo_location_clicked_cb={this.fetchGeoLocation.bind(this)}
                                temperature_unit_changed_cb={() => {
                                    this.siUnitToggle()
                                }}
                                temperature_si={this.state.si}
                                isPremiumUser={mIsPremiumUser}
                                showPremiumFeature={this.state.showPremiumFeature}
                            />
                        }
                        open={this.state.sidebarOpen}
                        onSetOpen={this.setSidebarOpen.bind(this)}
                        styles={{
                            sidebar: {
                                background: "white",
                                width: "270px",
                                zIndex: "201",
                                paddingBottom: "80px",
                                top: "0px",
                                overflowY: "hidden",
                            }
                        }}
                    >
                        <div className="weather-wrapper">
                            {this.showLocationDetectionComponent()}

                            <WeatherView
                                original_data={this.state.weatherResponse}
                                general_data={processedResp.general_data}
                                current_data={processedResp.current_data}
                                daily_data={processedResp.daily_data}
                                hourly_data={processedResp.hourly_data}
                                location_redirect={this.locationRedirect.bind(this)}
                                si_unit_toggle={this.siUnitToggle.bind(this)}
                                show_tool_tip={this.shouldShowToolTip()}
                                tool_tip_clicked_cb={this.toolTipClicked.bind(this)}
                                view_displayed_cb={() => {
                                    this.componentIsDisplayed()
                                }}
                                last_updated_time={this.state.lastUpdatedTime}
                                last_refresh_time={this.state.lastRefreshTime}
                                is_detect_location_notification_show={this.state.showLocationTopBar}
                                open_side_bar_cb={() => {
                                    this.setSidebarOpen(true)
                                }}
                                on_new_location_selected_from_finder={this.onNewLocationSelectedFromFinder.bind(this)}
                                ad_view={<AdView adType="1" />}
                                ad_view_large={<AdView adType="2" />}
                                frameStyle={this.state.frameStyle}
                                showSearchBar={this.state.showSearchBar}
                                isPremiumUser={mIsPremiumUser}
                                showPremiumFeature={this.state.showPremiumFeature}
                                alertTitle={this.state.alertTitle}
                            />
                        </div>
                    </Sidebar>
                )
            } else {
                // Only for debugging purposes
                return (
                    <WeatherDebugView
                        original_data={this.state.weatherResponse}
                        general_data={processedResp.general_data}
                        current_data={processedResp.current_data}
                        daily_data={processedResp.daily_data}
                        hourly_data={processedResp.hourly_data}
                    />
                )
            }
        }
    }

    componentWillUnmount() {
        console.log("Calling component unmount!")
        document.body.style.background = null;
        this.clearTimer()
        clearInterval(this.refreshWeatherJobTimerId);
    }

    // PRAGMA MARK :- Helper methods

    updateWeatherParamsWithGeoData(resp) {
        console.log("GEO_DATA: Setting the weather-geo-params with - ", resp)

        var area = null
        var city = resp["x-appengine-city"]
        var country = resp["x-appengine-country"]

        // Validate the lat-lon better
        var latLonStr = resp["x-appengine-citylatlong"]
        if (Utils.isEmptyStr(latLonStr)) {
            console.log("GEO_DATA: lat-lon string is empty!")
            return false
        }
        var latLonCompList = latLonStr.split(",")
        if (latLonCompList.length < 2) {
            console.log("GEO_DATA: Error splitting the lat-lon data")
            return false
        }
        var latitude = latLonCompList[0]
        var longitude = latLonCompList[1]
        var zipCode = null;
        this.weatherParams = new WeatherParams(latitude, longitude, area, city, country, zipCode, Constants.WEATHER_SRC.NATIVE_GEO)
        return true
    }

    updateSI() {
        var SI = this.state.si;

        // Fetch the SI state from the cache first. If absent then fetch from url
        var gotSIFromCache = false;
        console.log("SI: Fetching the si-preference from cache")
        var storedSIVal = null;
        if (false === Utils.isNull(DataSource)) {
            storedSIVal = DataSource.getItem(CACHE_SI_KEY);
        } else {
            console.log("LOCAL_STORAGE: Could not get local-storage object for getting the si-preference")
        }

        if (false === Utils.isNull(storedSIVal)) {
            console.log("SI: Got stored SI value")
            if (SIFormatter.isValidSIValue(storedSIVal)) {
                SI = storedSIVal;
                gotSIFromCache = true;
            } else {
                console.log("SI: Got invalid SI value")
            }
        } else {
            console.log("SI: No stored SI value")
        }

        if (gotSIFromCache === false) {
            var urlSI = Utils.getValForKeyFromCurrentUrl(Constants.ARGS.SI)
            if (typeof (urlSI) !== "undefined" && urlSI !== null) {
                urlSI = decodeURIComponent(urlSI.toLowerCase());
                if (urlSI === Constants.SI_UNIT_BRITISH || urlSI === Constants.SI_UNIT_US) {
                    SI = urlSI;
                } else {
                    console.log("Did not get valid SI from params. Using default")
                }
            }
        } else {
            console.log("SI: Skipping fetching the si-preference from url since it's available in the cache")
        }
        this.setState({ si: SI });
    }

    requestWeatherData() {
        if (Utils.isEmptyStr(this.weatherParams.latitude) || Utils.isEmptyStr(this.weatherParams.longitude)) {
            RemoteLogger.logStr("got empty lat-lon when requesting-weather-data")
            return
        }

        var reqHash = this.getLatLonHash(this.weatherParams.latitude, this.weatherParams.longitude)
        CacheStore.get(reqHash).then(cacheVal => {
            if (Utils.isNull(cacheVal)) {
                console.log("No entry found in cache for hash -" + reqHash);
            } else {
                var cachedResponse = cacheVal.response;
                var expiryTimestamp = cacheVal.expiry;
                var lastUpdatedTime = cacheVal.lastUpdatedTime;

                if (Utils.isNull(cachedResponse) || Utils.isNull(expiryTimestamp)) {
                    console.log("No entry found in cache for hash -" + reqHash);
                } else {
                    // Stale data check. If the data is too stale, then no point in using it
                    var currentTimestamp = Utils.getTimestampSecs()
                    if (currentTimestamp < expiryTimestamp) {
                        console.log("Got entry for hash - " + reqHash)
                        setTimeout(function () {
                            this.updateDOMWithResponse(cachedResponse, null, lastUpdatedTime)
                        }.bind(this), LOADER_DELAY);
                    } else {
                        console.log("Got expired entry - " + reqHash)
                    }
                }
            }
        }).catch(function (e) {
            console.log("Error getting data from cache-store" + e)
        }).then(function () {
            WeatherDataSource.fetchWeatherDataForLocation(this.weatherParams.latitude, this.weatherParams.longitude, function (response, error) {
                if (Utils.isNull(error) && false === Utils.isNull(response)) {
                    // Success
                    console.log("updating the idb response for - " + reqHash)
                    var lastUpdatedTime = Date.now()
                    var cacheIp = {
                        expiry: (Utils.getTimestampSecs() + EXPIRY_SECS),
                        response: response,
                        lastUpdatedTime: lastUpdatedTime,
                    }
                    CacheStore.set(reqHash, cacheIp)

                    setTimeout(function () {
                        this.updateDOMWithResponse(response, error, lastUpdatedTime)
                    }.bind(this), LOADER_DELAY)
                } else {
                    // Don't cache the response
                    if (this.state.isLoading) {
                        // Adding delay to remove flickering effect that people seem to be complaining about
                        /*
                        Performing the check twice to prevent situations like -
                        Scenario: Cached data available, goes offline
                        Without the inner check, the error-page is display if there already is data (isLoading state is modified during waiting for response)
                        */
                        setTimeout(function () {
                            if (this.state.isLoading) {
                                this.updateDOMWithResponse(null, error, null)
                            }
                        }.bind(this), LOADER_DELAY)
                    } else {
                        console.log("Couldn't fetch the response due to errors - " + error)
                    }
                }

                this.fetchDataAfterTimeoutPeriodically();
            }.bind(this));
        }.bind(this));
    }

    updateBodyTheme() {
        try {
            // Have to remove all the other themes before adding this
            document.body.classList.remove(...Theme.getAllThemesBodyClasses())
            document.body.classList.add(Theme.getThemeBodyClass());
        } catch (e) {
            console.log("Error applying theme for body")
        }
    }

    fetchAndLoadWeatherData() {
        this.updateBodyTheme()
        this.updateAreaFromZipCodeAsync()
        this.requestWeatherData()
    }

    componentIsDisplayed() {
        console.log("DISPLAY: Component is displayed")
        CommonComponents.AddWindowRefreshHandler(this.weatherRefreshHandler.bind(this))

        // Handler to when the location-data has changed
        window.LocationRefreshHandlerWithJSON = this.locationRefreshHandlerWithJSON.bind(this)

        // Handler to when the location permission has changed
        window.LocationPermissionAvailabilityStatus = this.locationPermissionStatus.bind(this)

        // Handler to capture sidebar visibility status
        window.SidebarVisibilityStatus = this.setNativeSidebarVisibility.bind(this)

        //Handler to capture user-id for analytics
        window.SetUniqueUserId = this.setUniqueUserId.bind(this)

        //Handler to capture user-id for analytics
        window.SetUniqueAffiliateId = this.setUniqueAffiliateId.bind(this)

        // Handler to set premium user status
        window.SetPremiumUsers = this.setPremiumUsers.bind(this)

        // Handler to set premium user status
        window.SetFCMToken = this.setFCMToken.bind(this)

        window.SetAlertMsg = this.setAlertMsg.bind(this)

        // Handler to refresh news
        window.RefreshNews = this.refreshNews.bind(this)

        // Call the native agent with page loaded
        NativeAgent.sendPageLoadedStatus()
    }

    setUniqueUserId(userId) {
        console.log("setting user-id: " + userId);
        UserIdManager.sendUserIdToAnalytics(userId);
    }

    setUniqueAffiliateId(afId) {
        console.log("setting affiliate-id: " + afId);

        if (false === Utils.isNull(afId)) {
            UserIdManager.sendAffiliateIdToAnalytics(afId);
        }
    }

    locationPermissionStatus(status) {
        if (Utils.isNull(status) || typeof status !== "number") {
            status = Constants.LOCATION_PERMISSION_STATUS.INVALID
        }

        // Update the store
        LocationPermissionStore.setPermissionStatus(status)

        switch (status) {
            case Constants.LOCATION_PERMISSION_STATUS.INVALID:
            case Constants.LOCATION_PERMISSION_STATUS.GRANTED:
                this.setState({ locationMode: LOCATION_MODE_LAT_LNG })
                if (this.isLocationDetectNotificationDisplayed()) {
                    this.dismissLocationDetectionNotification()
                }
                break;

            case Constants.LOCATION_PERMISSION_STATUS.DENIED:
                if (this.canShowLocationDetectNotificationBar()) {
                    this.setShouldDisplayLocationDetectNotification(true)
                }
                this.setState({ locationMode: LOCATION_MODE_IP })
                break;

            default:
                console.log("[LOCATION-PERMISSION]: Illegal status passed!")
        }
    }

    getLatLonHash(lat, lon) {
        if (Utils.isNull(lat) || Utils.isNull(lon)) {
            return ""
        } else {
            return DEFAULT_REQ_PREFIX + lat + "_" + lon
        }
    }

    // Function called when location data is in json format. Note that this is called from the native app
    locationRefreshHandlerWithJSON(locationData) {
        // Throttling
        if (false === Utils.isNull(this.lastLocationRefreshTime)) {
            var timeDiffSecs = (Date.now() - this.lastLocationRefreshTime) / 1000
            if (timeDiffSecs < Constants.LOCATION_REFRESH_THROTTLER_SECS) {
                console.log("LOC_REFRESH: Not performing location-refresh since it's being throttled within - (secs)", Constants.LOCATION_REFRESH_THROTTLER_SECS)
                return
            }
        }
        this.lastLocationRefreshTime = Date.now()

        if (Utils.isNull(locationData)) {
            RemoteLogger.logStr("LOC_REFRESH: Got empty/null entry for location-update!")
            return
        }

        try {
            var location = null
            if (typeof (locationData) === "string") {
                var locationStr = locationData;
                if (Utils.isEmptyStr(locationStr)) {
                    RemoteLogger.logStr("LOC_REFRESH: Got empty/null string for location-update!")
                    return
                }
                location = JSON.parse(locationStr)
            } else {
                location = locationData
            }

            if (Utils.isNull(location)) {
                RemoteLogger.logStr("LOC_REFRESH: Got null data in location-update!")
                return
            }

            console.log("LOC_REFRESH: Got location - ", location)

            // Extract out all the entries -
            let weatherParams = this.createWeatherParamsFromData(
                location[Constants.ARGS.LATITUDE],
                location[Constants.ARGS.LONGITUDE],
                location[Constants.ARGS.AREA],
                location[Constants.ARGS.CITY],
                location[Constants.ARGS.COUNTRY],
                location[Constants.ARGS.ZIP_CODE],
            )

            // Update the store
            LocationStore.addAndSendLocation(weatherParams)
        } catch (e) {
            RemoteLogger.log(e)
        }
    }

    /// Update location from native-geo
    createWeatherParamsFromData(lat, lon, street, city, country, zipCode) {
        // Validations -
        if (Utils.isEmptyStr(lat) || Utils.isEmptyStr(lon)) {
            RemoteLogger.logStr("LOC_REFRESH: Got lat-lon empty when updating data")
            return null
        }

        console.log("LOC_REFRESH: Got - ", lat, lon, street, city, country, zipCode)

        var newWeatherParams = new WeatherParams(
            lat,
            lon,
            street,
            city,
            country,
            zipCode,
            Constants.WEATHER_SRC.NATIVE_GEO,
        )
        return newWeatherParams
    }

    /// Load the new location in the UI from the new-weather-params.
    locationRefreshWithWeatherParams(newWeatherParams) {
        if (Utils.isNull(newWeatherParams) === true) {
            console.log("Not performing update since the weather params is empty!")
            return
        }

        // This needs to be partially equal (If lat-lon is different, but place is the same, then it should return true)
        if (true === this.weatherParams.areWeatherAreasEqual(newWeatherParams)) {
            console.log("Not performing update since the weather params are the same")
            return
        }

        // Display the loading page
        this.setState({
            isLoading: true,
        })

        this.weatherParams = newWeatherParams

        // Initiate the request process
        this.fetchAndLoadWeatherData()
    }

    // Handler for when the refresh page is called
    weatherRefreshHandler(version) {
        console.log("REFRESH: Refresh called!")

        // Decide whether to refresh the page or the perform api update
        if (VersionManager.isAppVersionLatest(version)) {
            console.log("REFRESH: App is latest!")

            // Perform api-call
            this.fetchDataAfterTimeoutPeriodically(300, (resp, err) => {
                var success = (Utils.isNull(err))
                var message = (success) ? Constants.REFRESH_SUCCESS_MESSAGE : Constants.REFRESH_ERROR_MESSAGE;

                // Tell the native agent whatever the status is
                this.updateNativeForRefreshWithData(
                    new RefreshDataState(
                        false,
                        false,
                        success,
                        message,
                    )
                )

                if (success === true) {
                    // Change state to tell the view about the refresh state
                    console.log("REFRESH_ANIMATE: refreshing -")
                    this.setState({
                        lastRefreshTime: Date.now()
                    })
                }
            })
        } else {
            console.log("REFRESH: App is stale! Reloading shortly...")

            // Tell the native agent about reload
            this.updateNativeForRefreshWithData(
                new RefreshDataState(
                    true,
                    false,
                    false,
                    ""
                )
            )

            // Refresh the page (reload from cache)
            setTimeout(() => {
                window.location.reload(true)
            }, 500)
        }
    }

    updateNativeForRefreshWithData(refreshData) {
        if (Utils.isNull(refreshData)) {
            console.log("REFRESH: Could not refresh since refresh-data is empty!")
            return
        }

        var refreshJSONStr = JSON.stringify(refreshData)
        console.log("REFRESH: Updating final status to native -", refreshJSONStr)
        NativeAgent.updateRefreshManagerStatus(refreshJSONStr)
    }

    /// Run the fetcher periodically.
    /// Both arguments provided will be only used for the very first run.
    /// They will be discarded from the second run and default values will be used.
    /// Default value (if null is provided)
    /// optTimeout - TIMEOUT_PERIOD
    /// optCb - null
    fetchDataAfterTimeoutPeriodically(optTimeout, optCb) {
        var timeoutPeriod = optTimeout
        if (Utils.isNull(optTimeout)) {
            timeoutPeriod = TIMEOUT_PERIOD;
        }

        console.log("CRON: Starting a set-time-out which will be run in - " + timeoutPeriod)

        // Need to explicitly clear the timeout before setting it again
        this.clearTimer()
        this.timeout = setTimeout(function () {
            WeatherDataSource.fetchWeatherDataForLocation(this.weatherParams.latitude, this.weatherParams.longitude, function (response, error) {
                console.log("CRON: Got cron response")
                if (Utils.isNull(error) && false === Utils.isNull(response)) {
                    var reqHash = this.getLatLonHash(this.weatherParams.latitude, this.weatherParams.longitude)
                    console.log("CRON: updating the idb response for - " + reqHash)
                    var lastUpdatedTime = Date.now()
                    var cacheIp = {
                        expiry: (Utils.getTimestampSecs() + EXPIRY_SECS),
                        response: response,
                        lastUpdatedTime: lastUpdatedTime,
                    }
                    CacheStore.set(reqHash, cacheIp)
                    this.updateDOMWithResponse(response, error, lastUpdatedTime)
                } else {
                    console.log("Got error!")
                }

                if (false === Utils.isNull(optCb)) {
                    console.log("CRON: calling cron callback ")
                    optCb(response, error)
                }

                // Restarting the fetch with default timeout
                this.fetchDataAfterTimeoutPeriodically();
            }.bind(this));
        }.bind(this), timeoutPeriod);
    }

    clearTimer() {
        console.log("TIMEOUT: Called!")
        if (false === Utils.isNull(this.timeout)) {
            console.log("TIMEOUT: clearing - ")
            clearTimeout(this.timeout)
            this.timeout = null;
        }
    }

    updateDOMWithResponse(response, error, lastUpdatedTime) {
        var hasFailed = false;
        if (typeof (error) !== "undefined" && error !== null) {
            console.log("Error when making the request")
            console.log(error);
            hasFailed = true;
        }

        // The final state map
        var finalStateMap = {
            weatherResponse: response,
            isLoading: false,
            hasFailed: hasFailed,
            lastUpdatedTime: lastUpdatedTime,
            latitude: this.weatherParams.latitude,
            longitude: this.weatherParams.longitude,
            country: this.weatherParams.country,
            zipCode: this.weatherParams.zipCode,
        }

        // If area were null, then area from zip-code can potentially fetch be fetched
        if (false === Utils.isNull(this.weatherParams.area)) {
            finalStateMap.area = this.weatherParams.area;
        }

        if (hasFailed === true) {
            console.log("REQUEST: Failed")

            // Remote logger requires error with Error type
            var errObj = error
            if (typeof (error) === "object") {
                var errStr = JSON.stringify(error)
                if (false === Utils.isNull(errStr)) {
                    errObj = new Error(errStr)
                }
            }
            RemoteLogger.log(errObj)
        }

        this.setState(finalStateMap);
    }

    // Handle tool-tip clicked
    toolTipClicked() {
        console.log("TOOLTIP: Clicked!")
        if (false === Utils.isNull(DataSource)) {
            DataSource.setItem(TOOL_TIP_SHOWN_KEY, true)
        }
    }

    // Logic to show the tool-tip
    shouldShowToolTip() {
        var isToolTipShown = false;
        if (false === Utils.isNull(DataSource)) {
            var toolTipShownVal = DataSource.getItem(TOOL_TIP_SHOWN_KEY);
            console.log("TOOLTIP: shown-val :", toolTipShownVal)
            if (false === Utils.isNull(toolTipShownVal)) {
                if (typeof toolTipShownVal === "string") {
                    toolTipShownVal = (toolTipShownVal === "true")
                }
                isToolTipShown = toolTipShownVal;
            }
        } else {
            console.log("LOCAL_STORAGE: Could not get local-storage object for getting the tool-tip")
        }

        // If already shown, don't show it. Hence the negation
        return !isToolTipShown;
    }

    siUnitToggle() {
        console.log("TOGGLING SI UNIT!");
        var newSiUnit = null;
        switch (this.state.si) {
            case Constants.SI_UNIT_BRITISH:
                newSiUnit = Constants.SI_UNIT_US;
                break
            case Constants.SI_UNIT_US:
                newSiUnit = Constants.SI_UNIT_BRITISH;
                break;
            default:
                console.log("Not toggling SI units since the state is invalid! - " + this.state.si)
        }

        if (false === Utils.isNull(newSiUnit)) {
            this.setState({ si: newSiUnit });
            console.log("SI: Updating si to - " + newSiUnit);
            if (false === Utils.isNull(DataSource)) {
                DataSource.setItem(CACHE_SI_KEY, newSiUnit);
            } else {
                console.log("LOCAL_STORAGE: Local storage is not available when setting!")
            }

            let currTempUnit = SIFormatter.getTempUnitForSI(newSiUnit)
            if (false === Utils.isNull(currTempUnit)) {
                Analytics.sendEvent(
                    Constants.ANALYTICS.EVENTS.CATEGORY.CLICK,
                    Constants.ANALYTICS.EVENTS.ACTION.TOGGLE_UNIT,
                    currTempUnit,
                )
            }
        }
    }

    locationRedirect() {
        console.log("Location redirect called!")
        this.clearTimer()
    }

    processWeatherResponse(response, area) {
        /*
        Ideally the response could look like this -
        {
            "general": {
                "si": "",
                "timezone": "",
                "location": {
                    "lat": "",
                    "lon": "",
                    "area_details": {
                        "area": "",
                        "city": ""
                    }
                },
                "last_updated":"",
            }
            "current": {
                "curr_temp": "",
                "max_temp": "",
                "min_temp": "",
                "icon": "",
                "sunrise_time": "",
                "sunset_time: """,
                "humidity": "",
                "wind_speed": "",
                "cloud_cover": "",
                "precipitation": ""
            },
            "hourly": [
                <WEATHER_ENTRY>
            ],
            "daily": [
                <WEATHER_ENTRY>
            ]

        }
        */
        var processedResp = {};

        // General data
        var locationData = {
            "lat": '' + response["latitude"],
            "lon": '' + response["longitude"],
            "lat_num": response["latitude"],
            "lon_num": response["longitude"],
            "area_details": area
        };

        var currentTime = Date.now();

        // Validating the timezone
        var timezone = response["timezone"];
        var latNum = locationData["lat_num"];
        var lonNum = locationData["lon_num"];
        if (false === Utils.isValidTimezone(timezone)) {
            var fetchedTimezone = Utils.getValidTimezoneFromLatLon(latNum, lonNum);
            if (false === Utils.isNull(fetchedTimezone)) {
                timezone = fetchedTimezone;
                console.log("TIMEZONE: Fetched timezone from tz-where - " + timezone)
            } else {
                console.log("TIMEZONE: Could not fetch valid timezone for - " + latNum + lonNum);
            }
        } else {
            console.log("TIMEZONE: Got valid timezone")
        }

        var generalData = {
            "si": this.state.si,
            "timezone": timezone,
            "last_updated": currentTime,
            "location": locationData
        }
        processedResp["general_data"] = generalData;

        let bulkProcessor = function (key) {
            var entriesList = []
            var rawEntries = response[key]["data"]
            if (rawEntries === null) {
                return entriesList;
            }
            for (var entryIndex in rawEntries) {
                var entry = new WeatherData(rawEntries[entryIndex], generalData)
                entriesList.push(entry)
            }
            return entriesList;
        }

        // Daily & hourly
        var dailyData = bulkProcessor("daily")
        processedResp["daily_data"] = dailyData;
        processedResp["hourly_data"] = bulkProcessor("hourly");

        // Current
        var currentEntry = new WeatherData(response["currently"], generalData)
        if (dailyData != null && dailyData.length > 0) {
            var firstEntry = dailyData[0];
            currentEntry.sunriseTime = firstEntry.sunriseTime
            currentEntry.sunsetTime = firstEntry.sunsetTime
            currentEntry.maxTemp = firstEntry.maxTemp
            currentEntry.minTemp = firstEntry.minTemp
        }

        processedResp["current_data"] = currentEntry;
        return processedResp;
    }

    /// Updates the area state with the zip-code only if -
    /// - this.weatherParams.area map is empty
    /// - this.weatherParams.country & this.weatherParams.zipCode are non-empty
    updateAreaFromZipCodeAsync() {
        if (false === Utils.isNull(this.weatherParams.area)) {
            console.log("AREA: Skip performing update with zip-code")
            return
        }

        var emptyArea = {
            "area": null
        }

        var country = this.weatherParams.country;
        var zipCode = this.weatherParams.zipCode;
        if (Utils.isNull(country) || Utils.isNull(zipCode)) {
            console.log("AREA: Skipping fetching area from postal code since country and/or zip_code is empty!")
            this.setState(emptyArea)
            return
        }
        console.log("AREA: Got country and zip for fetching from zip-code - ", country, zipCode)

        // Fetch the data
        WeatherDataSource.fetchAreaFromZipCodeForCountry(zipCode, country, (resp, respErr) => {
            if (false === Utils.isNull(respErr)) {
                console.log("AREA: Got error fetching area from location - ", respErr)
                this.setState(emptyArea)
                return
            }
            console.log("AREA: Got response! - ", resp)

            var found = resp["success"]
            if (Utils.isNull(found)) {
                found = false;
            }
            if (false === found) {
                console.log("AREA: Could not find any response for - ", zipCode, country)
                this.setState(emptyArea)
                return
            }

            var city = resp["city"]
            if (Utils.isNull(city)) {
                console.log("AREA: Got city-name to be null")
                this.setState(emptyArea)
                return
            }

            console.log("AREA: Found city - ", city)
            this.setState({ "area": Utils.formatArea(city.toLowerCase(), null) })
        })
    }

    // PRAGMA-MARK :- Location detection

    showLocationDetectionComponent() {
        let visibilityClass;
        switch (this.state.locationTopBarStatus) {
            case TOP_BAR_STATUS.INITIAL:
                visibilityClass = "initial-hide"
                break;
            case TOP_BAR_STATUS.SHOW:
                visibilityClass = "show"
                break;
            case TOP_BAR_STATUS.HIDE:
                visibilityClass = "hide"
                break;
            default:
                visibilityClass = "initial-hide"
        }
        console.log("VISIBILITY - ", visibilityClass)

        return (
            <div className={`location-notification-container ${visibilityClass}`}>
                <div className="location-notification-wrapper">
                    <a
                        href="inapp://location/detect"
                        className="detect-location-text"
                        onClick={this.triggerLocationDetection.bind(this)}
                    >
                        The weather location is approximate.<br />
                        Grant location permission for more accurate data.
                    </a>
                    <img
                        src="/image/close-btn.svg"
                        alt="Location detection notification"
                        className="detect-location-close"
                        onClick={this.dismissLocationDetectionNotification.bind(this)}
                    />
                </div>
            </div>
        )
    }

    setShouldDisplayLocationDetectNotification(shouldDisplay) {
        this.setState({
            showLocationTopBar: shouldDisplay,
            locationTopBarStatus: (shouldDisplay) ? TOP_BAR_STATUS.SHOW : TOP_BAR_STATUS.HIDE,
        })
    }

    isLocationDetectNotificationDisplayed() {
        return this.state.showLocationTopBar
    }

    canShowLocationDetectNotificationBar() {
        // This needs to be modified. Fetch data from the local-storage
        if (false === Utils.isNull(DataSource)) {
            try {
                let locationDetectStr = DataSource.getItem(Constants.LOCATION_DETECT_STORAGE_KEY);
                if (false === Utils.isNull(locationDetectStr) && locationDetectStr === Constants.LOCATION_DETECT_SHOWN_VAL) {
                    return false;
                } else {
                    return true
                }
            } catch (err) {
                console.log("Error displaying location - ", err)
            }
        }
        return false
    }

    triggerLocationDetection() {
        this.dismissLocationDetectionNotification()
    }

    dismissLocationDetectionNotification() {
        // Update the local-storage about the location-detection
        this.setShouldDisplayLocationDetectNotification(false)
        try {
            if (false === Utils.isNull(DataSource)) {
                DataSource.setItem(Constants.LOCATION_DETECT_STORAGE_KEY, Constants.LOCATION_DETECT_SHOWN_VAL);
            }
        } catch (err) {
            console.log("Error setting location data - ", err)
        }
    }

    // PRAGMA-MARK :- Sidebar functions

    setSidebarOpen(open) {
        SidebarStateStore.setIsSidebarOpen(open)
        this.setState({ sidebarOpen: open });
    }

    setNativeSidebarVisibility(visibility) {
        this.setState({ isNativeSidebarVisible: visibility });
    }

    setPremiumUsers(premiumUser) {
        mIsPremiumUser = premiumUser === '1' ? true : false
        DataSource.setItem(Constants.IS_PREMIUM_USER, mIsPremiumUser)
        this.forceUpdate()
    }

    /*
     showAlert -> true
     this.state.isPremiumUser -> false
     premiumStatus === '1' 
    */
    setAlertMsg(showAlert = 0) {
        let premiumStatus = Utils.getValForKeyFromCurrentUrl(Constants.ARGS.SHOW_PREMIUM_FEATURE)
        if (showAlert && !mIsPremiumUser && premiumStatus === '1') {
            this.setState({ alertTitle: 'Weather Alerts are available for your selected location(s)' });
        } else {
            this.setState({ alertTitle: '' });
        }
    }

    refreshNews(){
        DataSource.setItem(Constants.GENERAL_NEWS_REFRESH, true)
    }

    setFCMToken(fcmToken, deviceId) {
        if (Utils.isEmptyStr(fcmToken) || Utils.isEmptyStr(deviceId)) {
            console.log('Cannot set Empty string ', fcmToken, deviceId)
            return;
        }

        let tokenDetails = {
            [Constants.FCM_TOKEN]: fcmToken,
            [Constants.DEVICE_ID]: deviceId
        }
        DeviceTokenManger.storeToken(tokenDetails)
        LocationStore.sendSelectedLocations()
    }

    onSidebarEntryClicked(locationEntry, locationIndex, shouldCloseSidebar = false) {
        this.selectNewLocationFromSidebar(locationEntry, locationIndex)
        if (true === shouldCloseSidebar && true === SidebarStateStore.getIsSidebarOpen()) {
            this.setSidebarOpen(false)
        }
    }

    selectNewLocationFromSidebar(locationData, newLocIndex) {
        if (Utils.isNull(locationData)) {
            console.log("Not doing anything since the location is empty!")
            return
        }

        // Select the current location-entry & Initiate the request process
        LocationStore.setCurrentLocationIndex(newLocIndex)
        this.locationRefreshWithWeatherParams(locationData)
    }

    onNewLocationSelectedFromFinder(newLocation) {
        if (Utils.isNull(newLocation)) {
            console.log("Not doing anything since the new-location is empty!")
            return
        }

        this.setState({
            isLoading: true,
        })

        // Select the current location-entry & Initiate the request process
        this.weatherParams = newLocation
        this.fetchAndLoadWeatherData()

        // Add the new-location to the store
        LocationStore.addAndSendLocation(newLocation)
    }

    // Initiates the fetching of the geo location
    fetchGeoLocation() {
        console.log("GEO: Initiate detect-location")
        NativeAgent.initiateDetectLocation()
        Analytics.sendEvent(
            Constants.ANALYTICS.EVENTS.CATEGORY.LOCATION,
            Constants.ANALYTICS.EVENTS.ACTION.SELECT_LOC_PERMISSION,
        )
    }
}

export default WeatherApp;



// WEBPACK FOOTER //
// ./src/components/weather/weatherContainer.js